export default function calculateFeedRate(correctedRelubricationInterval: number, greaseQuantity: number): number {
  return calculate(correctedRelubricationInterval, greaseQuantity);
}

export function calculate(correctedRelubricationInterval: number, greaseQuantity: number): number {
  return (greaseQuantity / correctedRelubricationInterval) * 24;
}
